<template>
  <div id="" class="content" style="width: 100%;">
    <p class="fTitle"><label style="margin-left: 15px;">订单管理</label></p>
    <div class="conten-box">
      <div style="margin-bottom: 15px">
        <el-select v-model="matchId" @change="getMsgList" placeholder="请选择赛事">
          <!--<el-option label="2019上半年等级测试" value="1"></el-option>
          <el-option label="2019下半年等级测试" value="2"></el-option>-->
          <el-option v-for="(item , index) in listMatches" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
        <div class="status-box">
          <ul class="">
            <li :class="activeIndex==index?'active':''" @click="changeStatus(index)" v-for="(item,index) in statusList"  class="pay-status">{{item.name}}</li>
          </ul>
        </div>

      <div v-for="(firstItem,index) in  firstClass">
        <template>
          <div class="table-box">
            <div class="search-box">
              <span class="payDate">{{firstItem.createTime.split(' ')[0]}}</span>
              <span>订单号：</span>
              <span>{{firstItem.orderNo}}</span>
              <span class="money">￥{{firstItem.money}}</span>
            </div>
            <div class="table-content">
              <el-table
                :data="firstItem.orderDetail"
                size="mini"
                @selection-change="changeSelect($event,index)"
                border
                style="width: 100%">

                <el-table-column
                  label="编号"
                  type="index"
                  width="60">
                </el-table-column>

                <el-table-column
                  prop="personName"
                  label="姓名"
                  width="100">
                </el-table-column>

                <el-table-column
                  prop="gender"
                  label="性别"
                  :formatter="formatRole"
                  width="100">
                </el-table-column>

                <el-table-column
                  prop="credentialsNo"
                  label="证件号"
                  width="200"
                  show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                  prop="description"
                  label="项目">
                </el-table-column>

                <el-table-column
                  prop="cost"
                  width="100"
                  label="报名费">
                </el-table-column>
              </el-table>

              <div style="margin-top: 20px;text-align: right;" v-if="firstItem.payStatus=='N'">
                <button @click="deleteOrderStatus(firstItem.orderNo,firstItem.money)" v-if="identity!=3" :class="{'disarrow-pay-all':!haveList}" class="pay-all">删除</button>
                <p v-if="identity==3">15分钟后未支付，订单会自动删除！</p>
                <button @click="payAll(firstItem.orderNo,firstItem.money)" :class="{'disarrow-pay-all':!haveList}" class="pay-all">立即付款</button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import {get, post} from '@/api/fetch.js';
  import url from '@/api/serviceAPI.config.js';

  export default {
    data() {
      return {
        identity:"2",   //（2=组织，3=个人）
        events:'1',
        orgId:'8104',     //组织
        haveList:true,
        personId:24413,     //个人
        matchId:'',
        submitList:[],
        payStatus:'A',
          statusList:[{
            name:'全部订单',
            payStatus:'A'
          },{
            name:'已支付',
            payStatus:'Y'
          },{
            name:'未支付',
            payStatus:'N'
          }],
        activeIndex:0,
        firstClass:[
          {
            orderDate:'2019-09-09',
            money:'232',
            orderNo:78678,
            orderDetail:[{
              personName:'好好计划',
              description:'厦门自由化九级',
              gender:"女",
              credentialsNo:"51554548545454",
              cost:"4567",
            }]
          }
        ],
        listMatches:[]
      }
    },
    methods: {
      changeStatus(index){
        this.haveList=false;
        this.activeIndex=index;
        this.payStatus=this.statusList[index].payStatus;
        this.firstClass=[];
        this.getMsgList();
      },
      getMsgList(){
        this.firstClass=[];
        this.orgId=JSON.parse(sessionStorage.getItem("userId"));
        this.identity=JSON.parse(sessionStorage.getItem("type"));
        post(url.getAllOrderList,{matchId:this.matchId,id:this.orgId,orderStatus:this.payStatus,loginType:this.identity})
          .then(res=>{
          for(let item of res.data){
            let {orderNo,createTime,money,payStatus}=item.order;
            let orderDetails=item.orderDetails;
            let obj={
              createTime:createTime,
              money:money,
              orderNo:orderNo,
              payStatus:payStatus,
              orderDetail:[]
            };

            for(let i in orderDetails){
              let {personName,id,cost,gender,credentialsNo,description}=orderDetails[i].registrationInfo;
              let {money}=orderDetails[i].orderDetails;
              obj.orderDetail.push({
                cost: money||0,             //身份证
                personName: personName,
                gender: gender,
                credentialsNo: credentialsNo,
                description:description,
                id:id,
              })
            }
           this.firstClass.push(obj);
          }
        })
      },
      getGameLists(){
        post(url.listMatche).then(res=>{
          if(res.status==200)this.listMatches=res.data;
          this.matchId=this.listMatches[this.listMatches.length-1].id;
          this.getMsgList();
        })
      },
      formatRole: function(row, column) {
        return row.gender == '1' ? "男" : row.gender == '2' ? "女" : "性别不详";
      },
      selectable(row,column) {
        if (row.paystatus == 'Y'){//你需要判断的条件
          return 0;//不可勾选
        } else {
          return 1;//可勾选
        }
      },
      payAll(orderNo,money){
        this.$router.push({path:'/index/choosePayWay',query:{orderNo:orderNo,money:money}})
      },
      deleteOrderStatus(orderNo){
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          post(url.deleteOrderStatus,{orderNo:orderNo}).then(res=>{
            if(res.status==200){
              this.$notify({
                title: '删除成功',
                message: '删除成功',
                type: 'success',
                duration: 2000,
                onClose:()=>{
                  this.getMsgList();
                }
              });
            }else{
              this.$notify({
                title: '删除失败',
                message: '删除失败',
                type: 'error',
                duration: 2000
              });
            }
          })
        })
      },
      changeSelect(val,index) {
        let typetotalPrice=0;
        let totalPrice=0;
        let typeSubmitList=[];
        let submitList=[];

        for(var item of val){
          typetotalPrice+=parseInt(item.id);
          typeSubmitList.push(item.id);
        }
        this.firstClass[index].typetotalPrice=typetotalPrice;    //单个table总价
        this.firstClass[index].typeSubmitList=typeSubmitList;    //单个table勾选数据

        for(var items of this.firstClass){
          totalPrice+=items.typetotalPrice;
          submitList = submitList.concat(items.typeSubmitList)
        }
        this.submitList=submitList;
        if(this.submitList.length)this.haveList=true;
        else this.haveList=false;
        post(url.countMoney,{registrationInfoId:this.submitList}).then(res=>{
          this.totalPrice=res;
        })
      },
    },
    filters:{
      formatPay: function(paystatus) {
        return paystatus == 'N' ? "未支付" : paystatus == 'Y' ? "已支付" : "订单异常";
      },
    },
    created(){
      this.getMsgList();
      this.getGameLists();
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  .pay-all{
    padding: 7px 15px;
    border: none;
    background: #5a5cbb;
    color: #fff;
    cursor: pointer;
  }

  .fTitle{
    height: 32px;
    line-height: 32px;
    width: 100%;
    background: #fefefe;
    border: 1px solid #ddd;
    margin-bottom: 20px;
    color: #a7a7a7;
  }
  .status-box{
    height: 32px;
    border-bottom: 2px solid #5a5cbb;
  }
.pay-status{
  float: left;
  width: 110px;
  height: 31px;
  text-align: center;
  line-height: 31px;
  border: 1px solid #ddd;
  background: #f9f9f9;
  cursor: pointer;
  margin-right: 15px;
  border-bottom: none;
  color: #666;
}
  .search-box{
    height: 50px;
    background: #eaf8ff;
    line-height: 50px;
    border: 1px solid #e8e8e8;
    padding-left: 25px;
    border-bottom: none;
  }
  .table-content{
    padding: 20px;
    padding-bottom: 10px;
    border: 1px solid #e8e8e8;
  }
  .active{
    color: #fff;
    background: #5a5cbb;
  }
  .money{
    float: right;
    margin-right: 25px;
    color:#5a5cbb;
    font-weight: 600;
  }
  .payDate{
    margin-right: 20px;
  }

  .table-box{
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/payOrderList.vue